<template>
  <ul class="menu-nav">
    <router-link aria-haspopup="true" data-menu-toggle="hover" class="menu-item" to="/dashboard">
        <a class="menu-link">
            <span class="menu-text"> Inicio </span>
        </a>
    </router-link>
    <!--<li aria-haspopup="true" data-menu-toggle="click" class="menu-item menu-item-submenu menu-item-open-dropdown" v-bind:class="{ 'menu-item-active': hasActiveChildren('/custom') }">
        <a href="#" class="menu-link menu-toggle">
            <span class="menu-text"> Acreditacion </span>
        </a>

        <div class="menu-submenu menu-submenu-classic">
            <ul class="menu-subnav">
                <router-link aria-haspopup="true" data-menu-toggle="hover" class="menu-item" to="/athlete">
                    <a class="menu-link">
                    <span class="menu-text"> Deportistas </span>
                    </a>
                </router-link>

                <router-link aria-haspopup="true" data-menu-toggle="hover" class="menu-item" to="/official">
                    <a class="menu-link">
                    <span class="menu-text"> Oficiales </span>
                    </a>
                </router-link>
            </ul>
        </div>
    </li>
    <router-link aria-haspopup="true" data-menu-toggle="hover" class="menu-item" to="/credentials">
        <a class="menu-link">
            <span class="menu-text"> Credenciales </span>
        </a>
    </router-link>-->


    <router-link aria-haspopup="true" data-menu-toggle="hover" class="menu-item" to="/tutorials">
        <a class="menu-link">
            <span class="menu-text"> Tutoriales </span>
        </a>
    </router-link>


  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>
